import React from 'react';
import { GameCard } from '../GameCard';
import { Leaderboard } from '../Leaderboard';
import { games } from '../../data/games';
import type { User } from '../../types/user';

interface GameSelectionProps {
  user: User | null;
  onGameSelect: (index: number) => void;
}

export function GameSelection({ user, onGameSelect }: GameSelectionProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {games.map((game, index) => (
            <GameCard
              key={index}
              {...game}
              onClick={() => onGameSelect(index)}
              disabled={!user || user.points < game.entryFee}
            />
          ))}
        </div>
      </div>
      <div className="lg:col-span-1">
        <Leaderboard />
      </div>
    </div>
  );
}